import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import {
    DISABLED_BANKING_CATEGORIES,
    getCurrentUser,
    getOptionsByData,
    isEmpty,
    quickClone
} from "../../../../_helpers/commonFunctions";
import Dropdown from "../../../primer/Dropdown";
import EditableTable from "../../../primer/Editable-Table";
import axios from "axios";
import {toast} from "react-toastify";
import BetterCheckBox from "../../../common/BetterCheckBox";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import TextArea from "../../../common/TextArea";

const BankingCategoryModal = ({modalType, categoryType, defaultObject, show, setShow, callbackFunction}) => { // Manages new/edit category/subCategory
    // modalType = new / edit
    // categoryType = category / subCategory
    const company = useSelector(state => state.COMPANY_DATA.company);
    const [obj, setObj] = useState({});
    const [accounts, setAccounts] = useState([]);
    const [incrKey, setIncrKey] = useState(0);
    const [entitiesList, setEntitiesList] = useState([]);
    const [forceRefreshEntities, setForceRefreshEntities] = useState(false);
    const [reEntitiesList, setREEntitiesList] = useState([]);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const isAdmin = getCurrentUser()?.userType === "Admin";
    const isSales = permissionsData?.some((el) => el.permissionName === "custom-sales");

    const bankingCategories = useSelector((state) => state.ACCOUNTING_DATA.bankingCategories);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const documentTypeOptions = advancedTypes.filter((el) => el.section === obj.section).map((o) => {
        return {
            value: o._id,
            label: o.name,
        }
    });

    const accountingRecordCategories = useSelector((state) => state.ACCOUNTING_DATA.accountingRecordCategories);
    const categoryOptions = [{ label: "Κενό", value: ""}, ...getOptionsByData(accountingRecordCategories, "_id", "name")];

    const accountingRecordSubcategories = useSelector((state) => state.ACCOUNTING_DATA.accountingRecordSubcategories);
    const subCategoryOptions = [{ label: "Κενό", value: ""}, ...getOptionsByData(accountingRecordSubcategories, "_id", "name")];

    useEffect(() => {
        loadAccounts(null, setAccounts);
        loadEntitiesList(null, [setEntitiesList, setREEntitiesList]);
    }, [])

    useEffect(() => {
        if (forceRefreshEntities) {
            setForceRefreshEntities(false);
            loadEntitiesList(null, setEntitiesList);
        }
    }, [forceRefreshEntities])

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [obj?.accounts, accounts])

    const defaultEntityType = (() => {
        if (obj?.section === "Client Payments"
            || (obj?.section === "Accounting Records" && obj?.accounts?.some((el) => el.subAccountType === "client"))) {
            return "client";
        }
        if (obj?.section === "Supplier Payments"
            || (obj?.section === "Accounting Records" && obj?.accounts?.some((el) => el.subAccountType === "supplier"))) {
            return "supplier";
        }
        if (obj?.section === "Accounting Records" && obj?.accounts?.some((el) => el.subAccountType === "employee")) {
            return "employee";
        }
    })();

    const loadEntitiesList = (keyword, setData) => {
        if (!Array.isArray(setData)) setData = [setData];
        const entType = defaultEntityType;

        const reqData = { company: company.id }
        if (keyword) reqData.name = keyword;

        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/get-subAccount-by-word`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
                subAccountType: entType,
                keyword,
            },
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (Array.isArray(setData)) {
                    for (const func of setData) {
                        if (res.data.data) func(res.data.data);
                        else func([]);
                    }
                }
            } else {
                for (const func of setData) func([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const loadAccounts = (keyword = null, setData) => {
        const reqData = {
            company: company.id,
        };
        if (keyword !== null) reqData.keyword = keyword;

        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/account-list-by-advanced-type-id`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                code: keyword !== null ? keyword : undefined,
            }
        }).then((res) => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) setData(res.data.data);
                else setData([]);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const subCategoryAccountTableColumns = [
        {
            name: "Κωδικός Λογαριασμού",
            field: "code",
            width: "20%",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadAccounts(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Κωδικός Λογαριασμού", name: "code"},
                        {label: "Όνομα Λογαριασμού", name: "name"},
                    ],
                    data: accounts,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε λογιστικό λογαριασμό",
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Όνομα Λογαριασμού",
            field: "name",
            width: "30%",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadAccounts(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Κωδικός Λογαριασμού", name: "code"},
                        {label: "Όνομα Λογαριασμού", name: "name"},
                    ],
                    data: accounts,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε λογιστικό λογαριασμό",
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Προκαθορισμένη Οντότητα",
            field: "defaultSubAccount",
            width: "30%",
            editable: true,
            disabledCallback: (rowData) => !["client", "supplier", "employee"].includes(rowData.subAccountType),
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadEntitiesList(keyword, setData),
                    excludeColumns: [],
                    columns: ["client", "supplier"].includes(defaultEntityType) ? [
                        { label: "Κωδικός Συστήματος", name: "systemCode" },
                        { label: "Όνομα", name: "name" },
                        { label: "Τηλέφωνο", name: "phone" },
                        { label: "E-Mail", name: "email" },
                        { label: "Α.Φ.Μ.", name: "vatNumber" },
                    ] : [
                        { label: "Όνομα", name: "firstName" },
                        { label: "Επώνυμο", name: "lastName" },
                        { label: "Α.Φ.Μ.", name: "vatNumber" },
                    ],
                    data: entitiesList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε προκαθορισμένη οντότητα",
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Τύπος Γραμμής",
            field: "type",
            width: "20%",
            editable: true,
            inputType: {
                type: "select",
                options: [
                    {label: "Χρέωση", value: "debit"},
                    {label: "Πίστωση", value: "credit"},
                ],
            }
        },
    ]

    const signOptions = [
        {value: "+", label: "+"},
        {value: "-", label: "-"},
    ]

    const sectionOptions = [
        {value: "Client Payments", label: "Εισπράξεις Πελατών"},
        {value: "Supplier Payments", label: "Πληρωμές Προμηθευτών"},
        {value: "Accounting Records", label: "Λογιστικές Εγγραφές"},
    ]

    useEffect(() => {
        if (show) {
            setObj(defaultObject);
            setForceRefreshEntities(true);
        }
        else setObj({});
    }, [show]);

    const handleOnChange = (e, type, name) => {
        let prepChanges = {};
        if (type === "cb") {
            prepChanges[name] = e.target.checked;
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
        } else if (type === "dd") {
            prepChanges[name] = e.value;
        } else if (type === "acbox") {
            if (name === "defaultSubAccount") {
                const entType = defaultEntityType;
                if (["client", "supplier"].includes(entType)) {
                    prepChanges["defaultSubAccount"] = e.row.name;
                } else {
                    prepChanges["defaultSubAccount"] = `${e.row.firstName} ${e.row.lastName}`;
                }
                prepChanges["defaultSubAccountId"] = e.row._id;
                prepChanges["defaultSubAccountType"] = entType;
            }
        } else if (type === "msdd") {
            if (name === "restrictedEntitiesForMultipleInvoices") {
                const entType = defaultEntityType;
                prepChanges["restrictedEntitiesForMultipleInvoices"] = e.map((o) => {
                    return {
                        entityName: o.label,
                        entityId: o.value,
                        entityType: entType,
                    }
                });
            }
        }
        if (name === "section" && e.value !== obj.section) {
            prepChanges["documentType"] = "";
            if (obj?.restrictedEntitiesForMultipleInvoices?.length > 0) prepChanges["restrictedEntitiesForMultipleInvoices"] = [];
            if (obj?.supportMultipleInvoices) prepChanges["supportMultipleInvoices"] = false;
            if (obj?.supportMultipleEmployees) prepChanges["supportMultipleEmployees"] = false;
        }

        if (name === "section" && e.value !== obj.section) {
            setForceRefreshEntities(true);
            prepChanges.defaultSubAccount = "";
            prepChanges.defaultSubAccountType = "";
            prepChanges.defaultSubAccountId = "";
        }
        setObj({...obj, ...prepChanges});
    }

    const renderTitle = () => {
        if (modalType === "new") {
            if (categoryType === "category") return "Νέα Κατηγορία";
            else if (categoryType === "subCategory") return "Νέα Υποκατηγορία";
        } else if (modalType === "edit") {
            if (categoryType === "category") return "Επεξεργασία Κατηγορίας";
            else if (categoryType === "subCategory") return "Επεξεργασία Υποκατηγορίας";
        }
        return "";
    }

    const onTableAccountsChange = {
        insert: (e, data) => {
            if (data.field === "name" || data.field === "code") {
                const initRow = {
                    code: e.row.code,
                    name: e.row.name,
                    type: "credit",
                    isBanking: e.row.subAccount === "bankAccount",
                    subAccountType: e.row.subAccount,
                }
                const cloneData = obj.accounts.slice();
                cloneData.push(initRow);
                setObj({...obj, accounts: cloneData});
                if (e?.row && ["client", "supplier", "employee"].includes(e.row.subAccount)) setForceRefreshEntities(true);
            }
        },
        update: (data, id, rowIndex, e) => {
            const cloneData = quickClone(obj.accounts);
            if (data.name || data.code) {
                const matchingAcc = e.row;
                if (matchingAcc) {
                    cloneData[rowIndex] = {
                        ...cloneData[rowIndex],
                        code: matchingAcc.code,
                        name: matchingAcc.name,
                        isBanking: matchingAcc.subAccount === "bankAccount",
                        subAccountType: e.row.subAccount,
                        defaultSubAccount: "",
                        defaultSubAccountType: "",
                        defaultSubAccountId: "",
                    }
                }
            } else if (data.defaultSubAccount) {
                const entity = e.row;
                if (entity) {
                    cloneData[rowIndex] = {
                        ...cloneData[rowIndex],
                        defaultSubAccount: ["client", "supplier"].includes(defaultEntityType) ? entity.name : `${entity.firstName} ${entity.lastName}`,
                        defaultSubAccountType: defaultEntityType,
                        defaultSubAccountId: e.row._id,
                    }
                }
            } else {
                cloneData[rowIndex] = {...cloneData[rowIndex], ...data};
            }
            setObj({...obj, accounts: cloneData});
            if (e?.row && ["client", "supplier", "employee"].includes(e.row.subAccount)) setForceRefreshEntities(true);
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const cloneData = quickClone(obj.accounts);
            cloneData.splice(rowIndex, 1);
            setObj({...obj, accounts: cloneData});
        },
    }

    const parentCategoryTitle = obj?.parentCategory ? bankingCategories.find((el) => el._id === obj.parentCategory)?.title : null;

    const onSaveAttempt = () => {
        // Validations
        if (isEmpty(obj.title)) return toast.error("Παρακαλώ συμπληρώστε τίτλο.");

        if (categoryType === "category") {
            if (isNaN(+obj.threshold) || +obj.threshold < 50 || +obj.threshold > 100) return toast.error("Παρακαλώ συμπληρώστε αριθμητικό όριο μεταξύ 50 και 100.");
        } else if (categoryType === "subCategory") {
            if (["Client Payments", "Supplier Payments", "Accounting Records"].includes(obj.section)) {
                if (isEmpty(obj.documentType)) return toast.error("Παρακαλώ επιλέξτε τύπο παραστατικού.");
            }
            if (obj.section === "Accounting Records") {
                if (isEmpty(obj.balancingAccount)) return toast.error("Παρακαλώ συμπληρώστε λογαριασμό υπολοίπου.");
                if (isEmpty(obj.accountingCategory)) return toast.error("Παρακαλώ επιλέξτε λογιστική κατηγορία.");
                if (isEmpty(obj.accountingSubCategory)) return toast.error("Παρακαλώ επιλέξτε λογιστική υποκατηγορία.");
                const accountLimit = Math.max(["Πληρωμές Δημοσίου", "Λοιπά"].includes(parentCategoryTitle) ? String(obj.balancingAccount).split(",").length + 1 : 2, 2);
                if (obj.accounts.length > accountLimit && obj.title !== "Εκταμίευση Δανείου" && obj.title !== "Πληρωμή Δανείου") {
                    return toast.error(`Παρακαλώ επιλέξτε μόνο ${accountLimit} λογιστικούς λογαριασμούς.`);
                }
                if (!obj.accounts.some((el) => el.isBanking)) return toast.error("Ο ένας λογιστικός λογαριασμός πρέπει να έχει τραπεζικό υπολογαριασμό.");
            }
            if (parentCategoryTitle === "Λοιπά") {
                if (isNaN(+obj.threshold) || +obj.threshold < 50 || +obj.threshold > 100) return toast.error("Παρακαλώ συμπληρώστε αριθμητικό όριο μεταξύ 50 και 100.");
                if ((obj.supportMultipleEmployees || obj.supportMultipleInvoices) && (isNaN(+obj.maximumCombinationAmount) || +obj.maximumCombinationAmount < 2 || +obj.maximumCombinationAmount > 20)) {
                    return toast.error("Παρακαλώ συμπληρώστε μέγιστο πλήθος συνδυασμού πολλαπλών παραστατικών από 2 έως 20.");
                }
            }
        }

        callbackFunction(obj);
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={categoryType === "category" ? "modal42PercentWidth" : "modal65PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>{renderTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(show && Object.keys(defaultObject).length > 0) && (
                    <React.Fragment>
                        <Row className={"mb-2"}>
                            <Col md={6}>
                                <Input
                                    name={"title"}
                                    label={`Τίτλος ${categoryType === "category" ? "κατηγορίας" : "υποκατηγορίας"}`}
                                    value={obj.title}
                                    required={true}
                                    autoComplete={"off"}
                                    disabled={DISABLED_BANKING_CATEGORIES.includes(obj.title)}
                                    onChange={(e) => handleOnChange(e, "input", "title")}
                                />
                            </Col>
                            {(categoryType === "category" && obj.title !== "Λοιπά") && (
                                <Col md={6}>
                                    <Input
                                        name={"threshold"}
                                        label={`Άριθμητικό Όριο (50 έως 100)`}
                                        value={obj.threshold}
                                        required={true}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "threshold")}
                                    />
                                </Col>
                            )}
                            {categoryType === "subCategory" && (
                                <React.Fragment>
                                    <Col md={6}>
                                        <Dropdown
                                            name={"transactionSign"}
                                            options={signOptions}
                                            label={"Πρόσημο συναλλαγής"}
                                            defaultValue={signOptions.find((el) => el.value === obj.transactionSign)}
                                            disabled={DISABLED_BANKING_CATEGORIES.includes(obj.title)}
                                            onChange={(e) => handleOnChange(e, "dd", "transactionSign")}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Dropdown
                                            name={"section"}
                                            options={sectionOptions}
                                            label={"Κατηγορία Εγγραφής"}
                                            defaultValue={sectionOptions.find((el) => el.value === obj.section)}
                                            onChange={(e) => handleOnChange(e, "dd", "section")}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                            {["Client Payments", "Supplier Payments", "Accounting Records"].includes(obj.section) && (
                                <React.Fragment>
                                    <Col md={6}>
                                        <Dropdown
                                            name={"documentType"}
                                            options={documentTypeOptions}
                                            label={"Τύπος Παραστατικού"}
                                            defaultValue={documentTypeOptions.find((el) => el.value === obj.documentType)}
                                            required={true}
                                            onChange={(e) => handleOnChange(e, "dd", "documentType")}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                            {(parentCategoryTitle === "Λοιπά" || isAdmin) && (
                                <Col md={12}>
                                    <TextArea
                                        label={"AI Οδηγίες κατηγορίας"}
                                        rows={3}
                                        value={obj.aiInstructions}
                                        onChange={(e) => handleOnChange(e, "input", "aiInstructions")}
                                        limit={1000}
                                        disabled={!(isSales || isAdmin)}
                                    />
                                </Col>
                            )}
                            {obj.section === "Accounting Records" && (
                                <React.Fragment>
                                    <Col md={4}>
                                        <Dropdown
                                            name={"accountingCategory"}
                                            options={categoryOptions}
                                            label={"Λογιστική Κατηγορία"}
                                            defaultValue={categoryOptions.find((el) => el.value === obj.accountingCategory)}
                                            required={true}
                                            onChange={(e) => handleOnChange(e, "dd", "accountingCategory")}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Dropdown
                                            name={"accountingSubCategory"}
                                            options={subCategoryOptions}
                                            label={"Λογιστική Υποκατηγορία"}
                                            defaultValue={subCategoryOptions.find((el) => el.value === obj.accountingSubCategory)}
                                            required={true}
                                            onChange={(e) => handleOnChange(e, "dd", "accountingSubCategory")}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Input
                                            name={"balancingAccount"}
                                            label={"Λογιστικός Λογαριασμός Υπολοίπου"}
                                            value={obj.balancingAccount}
                                            autoComplete={"off"}
                                            required={true}
                                            onChange={(e) => handleOnChange(e, "input", "balancingAccount")}
                                        />
                                    </Col>
                                    <Col md={12} className={"mt-3"}>
                                        <EditableTable
                                            tableName={"SubCategory Account Table"}
                                            key={"SubCategory Account Table" + incrKey}
                                            allowActions={true}
                                            onUpdate={onTableAccountsChange}
                                            allowInsertRow="true"
                                            columns={subCategoryAccountTableColumns}
                                            enableNewRowCheckbox={true}
                                            data={obj.accounts}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                        </Row>
                        {obj.title === "Εκταμίευση Δανείου" && (
                            <Row>
                                <Col md={4}>
                                    <Input
                                        name={"loanAccount"}
                                        label={"Μορφή λογστικού λογαριασμού δανείων"}
                                        value={obj.loanAccount}
                                        autoComplete={"off"}
                                        required={true}
                                        allowSpecialCharacters={true}
                                        onChange={(e) => handleOnChange(e, "input", "loanAccount")}
                                    />
                                </Col>
                            </Row>
                        )}
                        {parentCategoryTitle === "Λοιπά" && (
                            <Row className={"mb-3"}>
                                <Col md={4}>
                                    <Input
                                        name={"threshold"}
                                        label={`Άριθμητικό Όριο Score Αποδοχής (50 έως 100)`}
                                        value={obj.threshold}
                                        required={true}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "threshold")}
                                    />
                                </Col>
                                {["Client Payments", "Supplier Payments"].includes(obj.section) && (
                                    <React.Fragment>
                                        <Col md={4}>
                                            <div style={{marginTop: "23px"}}>
                                                <BetterCheckBox
                                                    name={"supportMultipleInvoices"}
                                                    text={"Ενεργοποίηση λειτουργίας εύρεσης πολλαπλών παραστατικών"}
                                                    checked={obj.supportMultipleInvoices}
                                                    onChange={(e) => handleOnChange(e, "cb", "supportMultipleInvoices")}
                                                />
                                            </div>
                                        </Col>
                                        {obj.supportMultipleInvoices && (
                                            <React.Fragment>
                                                <Col md={4}>
                                                    <Input
                                                        name={"maximumCombinationAmount"}
                                                        label={"Μέγιστο πλήθος συνδυασμού πολλαπλών παραστατικών"}
                                                        value={obj.maximumCombinationAmount}
                                                        autoComplete={"off"}
                                                        type={"number"}
                                                        onChange={(e) => handleOnChange(e, "input", "maximumCombinationAmount")}
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <Dropdown
                                                        name={"restrictedEntitiesForMultipleInvoices"}
                                                        label={"Περιορισμός Ενδιάμεσων Οντοτήτων"}
                                                        options={reEntitiesList.map((el) => ({label: el.name, value: el._id}))}
                                                        onChangeSearch={(keyword) => loadEntitiesList(keyword, setREEntitiesList)}
                                                        enabledValue={true}
                                                        searchEnable={true}
                                                        multiSelect={true}
                                                        defaultValue={(obj?.restrictedEntitiesForMultipleInvoices || []).map((o) => {
                                                            return {
                                                                value: o.entityId,
                                                                label: o.entityName,
                                                            }
                                                        })}
                                                        onChange={(e) => handleOnChange(e, "msdd", "restrictedEntitiesForMultipleInvoices")}
                                                    />
                                                </Col>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )}
                                {(obj.section === "Accounting Records" && obj.accounts.some((el) => el.subAccountType === "employee")) && (
                                    <React.Fragment>
                                        <Col md={4}>
                                            <div style={{marginTop: "23px"}}>
                                                <BetterCheckBox
                                                    name={"supportMultipleEmployees"}
                                                    text={"Ενεργοποίηση λειτουργίας εύρεσης πολλαπλών εργαζομένων"}
                                                    checked={obj.supportMultipleEmployees}
                                                    onChange={(e) => handleOnChange(e, "cb", "supportMultipleEmployees")}
                                                />
                                            </div>
                                        </Col>
                                        {obj.supportMultipleEmployees && (
                                            <Col md={4}>
                                                <Input
                                                    name={"maximumCombinationAmount"}
                                                    label={"Μέγιστο πλήθος συνδυασμού πολλαπλών εργαζομένων"}
                                                    value={obj.maximumCombinationAmount}
                                                    autoComplete={"off"}
                                                    type={"number"}
                                                    onChange={(e) => handleOnChange(e, "input", "maximumCombinationAmount")}
                                                />
                                            </Col>
                                        )}
                                    </React.Fragment>
                                )}
                            </Row>
                        )}
                        <Row>
                            {["Client Payments", "Supplier Payments"].includes(obj.section) && (
                                <Col md={6}>
                                    <AdvancedCombobox
                                        name="defaultSubAccount"
                                        className="w-100 ac-select-dropdown"
                                        defaultValue={obj.defaultSubAccount}
                                        label={"Προκαθορισμένη Οντότητα"}
                                        data={entitiesList}
                                        key={obj.defaultSubAccount}
                                        onChange={(e) => handleOnChange(e, "acbox", "defaultSubAccount")}
                                        resetFilter={() => {
                                            setObj({
                                                ...obj,
                                                defaultSubAccount: "",
                                                defaultSubAccountType: "",
                                                defaultSubAccountId: "",
                                            })
                                        }}
                                        onChangeSearch={loadEntitiesList}
                                        excludeColumns={[]}
                                        columns={[
                                            {label: "Όνομα", name: "name"},
                                            {label: "ΑΦΜ", name: "vatNumber"},
                                            {label: "Τηλέφωνο", name: "phone"},
                                        ]}
                                        deleteEnable={false}
                                        searchTableEnable={false}
                                        showTableOptionOnSelect={true}
                                        placeholder={"Επιλέξτε προκαθορισμένη οντότητα"}
                                        showInsertAddButton={true}
                                        hideSaveButton={true}
                                        hideInsertNewRow={true}
                                        inputFieldClasses="form-control"
                                        autoLock={true}
                                    />
                                </Col>
                            )}
                            {(["Client Payments", "Supplier Payments"].includes(obj.section)
                                || (obj.section === "Accounting Records" && obj?.accounts?.some((el) => !isEmpty(el.defaultSubAccountId)))) && (
                                <Col md={6}>
                                    <div style={{marginTop: "33px"}}>
                                        <BetterCheckBox
                                            name={"replaceWithDefault"}
                                            text={"Να γίνεται αντικατάσταση της προκαθορισμένης οντότητας"}
                                            checked={obj.replaceWithDefault}
                                            onChange={(e) => handleOnChange(e, "cb", "replaceWithDefault")}
                                        />
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                {categoryType === "subCategory" && (
                    <div style={{marginTop: "28px", paddingRight: "20px"}}>
                        <BetterCheckBox
                            name={"isActive"}
                            text={"Ενεργοποίηση υποκατηγορίας"}
                            checked={obj.isActive}
                            onChange={(e) => handleOnChange(e, "cb", "isActive")}
                        />
                    </div>
                )}
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onSaveAttempt()}>
                    Αποθήκευση
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default BankingCategoryModal;
